import { Col, Sidepanel, Spinner2, Text } from 'components';
import { theme } from 'lib';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { ContentHeader } from 'screens/Admin/components';
import { Settings } from 'screens/Admin/components/PostPanel/components';
import P4PReplayPost from './P4PReplayPost';
import { Api } from 'lib';

const UploadingOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
  background-color: rgba(210, 216, 223, 0.7);
`;

const P4PReplayPostPanel = ({ post, setDataId, closeModal, hasBack, onSuccess, team }) => {
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    setUploading(false);
  }, [post]);

  return (
    <Sidepanel wid={600} pad="0" visible={post} closeModal={uploading ? undefined : closeModal}>
      {uploading && (
        <UploadingOverlay>
          <Col centerAll ht="100%">
            <Col noFlex center>
              <Spinner2 />
            </Col>

            <Text med marg="24px 0 0">
              Please don't close this tab while your video is uploading
            </Text>
          </Col>
        </UploadingOverlay>
      )}

      <ContentHeader
        text={
          !post ? 'Create new post' : `Editing ${post?.owner?.name || post?.owner?.username}'s post`
        }
        SettingsComponent={() => <Settings post={post} closeModal={() => setDataId(null)} />}
        closePanel={hasBack && closeModal}
      />

      {post && (
        <P4PReplayPost
          post={post}
          setDataId={setDataId}
          closeModal={closeModal}
          isEditing={!!post}
          setUploading={setUploading}
          isProcessing={post?.processing}
          onSuccess={onSuccess}
          team={team}
        />
      )}
    </Sidepanel>
  );
};

export default P4PReplayPostPanel;
